"use strict";

var _classCallCheck = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTrackerRegistry = exports.TrackerRegistry = void 0;

var HashUtil_1 = require("./HashUtil");

var TrackerRegistry = /*#__PURE__*/function () {
  function TrackerRegistry(records) {
    _classCallCheck(this, TrackerRegistry);

    this.records = records.slice(); // copy before mutating
  }

  _createClass(TrackerRegistry, [{
    key: "getTracker",
    value: function getTracker(streamPartId) {
      var index = (0, HashUtil_1.keyToArrayIndex)(this.records.length, streamPartId);
      return this.records[index];
    }
  }, {
    key: "getAllTrackers",
    value: function getAllTrackers() {
      return this.records;
    }
  }]);

  return TrackerRegistry;
}();

exports.TrackerRegistry = TrackerRegistry;

function createTrackerRegistry(servers) {
  return new TrackerRegistry(servers);
}

exports.createTrackerRegistry = createTrackerRegistry;